<template>
<p :class="item.class || ''">
  <router-link :to="item.to || undefined">
    {{ item.value }}
  </router-link>
</p>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyLink',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },

  data: () => ({
    itemValue: ''
  }),

  mounted () {
    this.itemValue = this.value || this.itemValue
  },

  watch: {
    itemValue: function (newVal, oldVal) {
      this.$emit('change', newVal)
      this.$emit('on-change', newVal, oldVal, this.item)
    }
  },

  methods: {
    focusNextField: function (event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-link.vue